"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.galleryTags.name': 'Etiquetas de Galería',
    'tools.galleryTags.description': 'Gestionar y organizar el contenido de la galería con etiquetas',
};
